import { useState } from "react";
import { Filter } from "../components/filter";
import { ViewOrganizations } from "../components/view-organizations";
import { AddOrganization } from "../components/add-organization";
import CreateAccountCustom from "../components/CreateAccountCustom";
import CreatePrayerPartner from "../components/CreatePrayerPartner";

export const SubscribersPage = () => {
    const [showAddOrg, setShowAddOrg] = useState(false);
    const [showCreateAccount, setShowCreateAccount] = useState(false);
    const [showAgentModal, setShowAgentModal] = useState(false);


  return (
    <div className="m-0">
        
          
          <div className="flex w-full items-center justify-center gap-4 flex-nowrap">
              <button
                  className="admin-button add-org-btn"
                  onClick={() => setShowAddOrg(true)}
              >
                  ADD ORGANIZATION
              </button>
              <button
                  className="admin-button create-account-btn"
                  onClick={() => setShowCreateAccount(true)}
              >
                 ADD USER
              </button>
              <button
                  className="admin-button prayer-request-btn"
                  onClick={() => setShowAgentModal(true)}
              >
                  ADD AGENT [Twilio]
              </button>
          </div>
          <header className="mt-3 mb-2 text-center font-['Futura_PT'] bg-[#F1F1F1] rounded p-1 text-[#178B96]">
              <h1>Subscribers</h1>
          </header>
          <div className="flex w-full items-center gap-4 flex-nowrap">
              <div className="min-w-0 flex-1">
                  <Filter page={"superAdminDashboard"} defaultSearchBy={"name"} />
              </div>
          </div>
      <ViewOrganizations />
      <AddOrganization
        setShow={setShowAddOrg}
        show={showAddOrg}
        onHide={() => setShowAddOrg(false)}
      />
          <CreateAccountCustom
              showLock={showCreateAccount}
              setShowLock={setShowCreateAccount}
          />
          <CreatePrayerPartner
              showLock={showAgentModal}
              setShowLock={setShowAgentModal}
          />
    </div>
  );
};
